import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { authAPI } from "../../api/auth/auth"

const initialState = {
    status: null,
    error: null,
    registrated: false,
}

export const registrationThunk = createAsyncThunk(
    "registration/registrationThunk",
    async({email, password, name, userType}, {rejectWithValue})  => {
        const resp = await authAPI.registrate(name, email, password, userType)
        if (resp.ok) {
            return {
                "ok": true
            }
        }
        if(resp.err) {
            return rejectWithValue({"err": resp.err})
        }
        return rejectWithValue({"err": 'something_went_wrong'})
    }
)

const registrationSlice = createSlice({
    name: "registration",
    initialState,
    reducers: {
        setRegistrated(state, action) {
            state.registrated = action.payload
        }
    },
    extraReducers(builder) {
        builder.addCase(registrationThunk.fulfilled, (state, action) => {
            state.registrated = true
            state.status = 'fulfilled'
            state.error = null
        })
        builder.addCase(registrationThunk.pending, (state, action) => {
            state.registrated = false
            state.status = 'pending'
            state.error = null
        })
        builder.addCase(registrationThunk.rejected, (state, action) => {
            const {err} = action.payload
            state.registrated = false
            state.status = 'rejected'
            
            if(err) {
                state.error = err
                return
            }

            state.error = 'something_went_wrong'
        })
    }
})

export const { setRegistrated } = registrationSlice.actions

export const selectRegistrationStatus = (state) => state.registration.status
export const selectRegistrationError = (state) => state.registration.error
export const selectRegistrated = (state) => state.registration.registrated

export default registrationSlice.reducer